export default __webpack_public_path__ + "static/media/card-docs.3ceaddfb.png";